/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagListResponse } from '../../models/tag-list-response';
import { TagType } from '../../models/tag-type';

export interface GetTags$Params {
  'Active-Tenant-Identifier': string;
  tagType?: TagType;
}

export function getTags(http: HttpClient, rootUrl: string, params: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagListResponse>> {
  const rb = new RequestBuilder(rootUrl, getTags.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('tagType', params.tagType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagListResponse>;
    })
  );
}

getTags.PATH = '/tags';
